export * from '@fhs/routing/src/routes/(tabs)/rewards/list/[rewardId]';
export { default } from '@fhs/routing/src/routes/(tabs)/rewards/list/[rewardId]';
